module.exports = __webpack_public_path__ + "static/media/bg_home.173338b7.webp";